module.exports = __webpack_public_path__ + "img/yurtici-logo.78d21327.png";